
            const data = {"name":"glyph/10/triangle-down","data":{"width":"7","height":"4","viewBox":"0 0 7 4","data":"<path pid=\"0\" _fill=\"#272c33\" fill-rule=\"nonzero\" d=\"M3.5 4 7 0H0z\"/>","originalColors":[{"type":"fill","color":"#272c33"}],"stopColors":[]}}
        
                    module.exports = data
                    